import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import Link from '@material-ui/core/Link';

export default function CancelDialog(props) {
  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Are you sure you want to permanently delete this application?'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Link
            component="button"
            variant="h6"
            color="primary"
            onClick={props.close}
          >
            CANCEL
          </Link>
          <Button
            onClick={props.delete}
            color="primary"
            variant="contained"
            autoFocus
            style={{ paddingRight: 35, paddingLeft: 35 }}
          >
            DELETE
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

CancelDialog.propTypes = {
  content: PropTypes.string,
  open: PropTypes.bool,
  close: PropTypes.func,
  delete: PropTypes.func,
};
